import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import service from '../Services/service';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { CreateUserRowPermission } from '../Helper/PermissionHelper';
import { GroupListhooks } from '../Helper/GroupHelper';

const ShareModal = ({ show, handleClose, screenName, moduleId, rowId }) => {
    const [users, setUsers] = useState([]);
    const [moduleName, setModuleName] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    const [shareWith, setShareWith] = useState('User'); // 'Everyone', 'UserGroup', 'User'
    const [userGroups, setUserGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [sharedPermissions, setSharedPermissions] = useState([]);
    const [sharedUserGroups, setSharedUserGroups] = useState([]);

    const [permissions, setPermissions] = useState({
        canView: false,
        canEdit: false,
        canDelete: false,
        canAssign: false
    });

    useEffect(() => {
        if (show) {
            setModulename();
            fetchUsers();
            fetchGroups();
            resetState();
        }
    }, [show]);

    const setModulename = () => {
        const moduleMap = {
            1: 'Layout',
            2: 'Screen',
            3: 'User',
            4: 'Campaign',
            5: 'Schedule',
            6: 'Content',
            7: 'Group',
            8: 'Permission',
        };
        const name = moduleMap[moduleId];
        if (name) setModuleName(name);
    };


    const fetchSharedPermissions = async () => {
        const res = await service.getdata(
            `Permission/GetAllUserModuleId?moduleId=${moduleId}&rowId=${rowId}`
        );

        const data = res.data || [];

        // User permissions
        const users = data.filter(x => x.userId != null && x.userId > 0);

        // User Group permissions
        const groups = data.filter(x =>
            (x.userId == null || x.userId === 0) &&
            x.groupId != null &&
            x.groupId > 0
        );


        setSharedPermissions(users);
        setSharedUserGroups(groups);
    };

    useEffect(() => {
        if (show) {
            fetchSharedPermissions();
        }
    }, [show]);

    const fetchUsers = async () => {
        const userId = localStorage.getItem("userId");
        try {
            const response = await service.getdata(`User/GetAll?sortBy=Name&sortDescending=false&pageNumber=1&pageSize=1000&userId=${userId}`);
            if (response?.data?.items) {
                setUsers(response.data.items);
            }
        } catch (error) {
            toast.error('Failed to fetch users.');
        }
    };

    const fetchGroups = async () => {
        try {
            const data = await GroupListhooks("", "Name", false, 1, 1000, 3);
            if (data) {
                setUserGroups(data.items);
            }
        } catch (error) {
            toast.error('Failed to fetch user groups.');
        }
    };

    const fetchUserPermissions = async (userId) => {
        try {
            const response = await service.getdata(`Permission/GetByUserModuleId?id=${userId}&moduleId=${moduleId}&rowId=${rowId}`);
            if (response?.data) {
                const userPerms = response.data;
                setPermissions({
                    canView: userPerms.canView ?? false,
                    canEdit: userPerms.canEdit ?? false,
                    canDelete: userPerms.canDelete ?? false,
                    canAssign: userPerms.canAssign ?? false
                });
            }

        } catch (error) {
            toast.error('Failed to load user permission data.');
            resetState();
        }
    };

    const getDisplayName = (item) => {
        // if (item.everyone) {
        //     return "Everyone";
        // }

        if (item.userId > 0) {
            const user = users.find(u => u.userId === item.userId);
            return user
                ? `${user.username} (${user.firstName} ${user.lastName})`
                : `User #${item.userId}`;
        }

        if (item.groupId > 0) {
            const group = userGroups.find(g => g.groupId === item.groupId);
            return group
                ? group.groupName
                : `Group #${item.usergroupId}`;
        }

        return "Unknown";
    };

    const resetState = () => {
        setSelectedUser(null);
        setPermissions({
            canView: false,
            canEdit: false,
            canDelete: false,
            canAssign: false
        });
    };

    const removePermission = async (id) => {

        const response = await service.getdata(`Permission/DeleteRowPermission?id=${id}`);
        toast.success("Permission removed");
        fetchSharedPermissions();
    };

    const editPermission = (item) => {
  
        setSelectedUser(item.userId);
        setSelectedGroup(item.groupId);

        setPermissions({
            canView: item.canView,
            canEdit: item.canEdit,
            canDelete: item.canDelete,
            canAssign: item.canAssign
        });
    };

   const userOptions = users
    .filter(user =>
        user.roleName?.trim().toLowerCase() !== "admin"
    )
    .map(user => ({
        value: user.userId,
        label: `${user.username} (${user.firstName} ${user.lastName})`,
    }));

    const groupOptions = userGroups.map(group => ({
        value: group.groupId,
        label: group.groupName
    }));

    const handleSubmit = async (e) => {
       
        e.preventDefault();
        let userId = 0;
        let groupId = 0;
        let usergroupId = 0;
        let everyone = false;

        if (shareWith === 'Everyone') {
            everyone = true;
        } else if (shareWith === 'UserGroup') {
            if (!selectedGroup) {
                toast.error("Please select a user group.");
                return;
            }
            usergroupId = selectedGroup;
        } else if (shareWith === 'User') {
            if (!selectedUser) {
                toast.error("Please select a user.");
                return;
            }
            userId = selectedUser;
        }

        const payload = {
            rowPermissionId: 0,
            moduleId,
            rowId,
            userId,
            groupId,            // Assuming not used now but still included
            everyone,
            usergroupId,
            ...permissions,
            createdDate: new Date().toISOString(),
            createdby: parseInt(localStorage.getItem("userId"))
        };

        try {
            const res = await CreateUserRowPermission(payload);
            if (res !== undefined) {
                toast.success('Row Permission created successfully!');
                handleClose();
            } else {
                toast.error('Failed to create Row permission. Please try again!');
            }
        } catch (error) {
            toast.error('An error occurred while creating the permission.');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <form onSubmit={handleSubmit}>
                <Modal.Header className="border-bottom bg-light">
                    <Modal.Title className="w-100 text-center text-primary">
                        Share Access - {moduleName} - {screenName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="form-group mb-3">
                        <label className="font-weight-bold text-secondary">Share With</label>
                        <div className="d-flex gap-3 mt-2">
                            {['UserGroup', 'User'].map(option => (
                                <div className="form-check form-check-inline" key={option}>
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="shareWith"
                                        id={`share-${option}`}
                                        checked={shareWith === option}
                                        onChange={() => setShareWith(option)}
                                    />
                                    <label className="form-check-label" htmlFor={`share-${option}`}>
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    {shareWith === 'User' && (
                        <>
                            <div className="form-group">
                                <label className="font-weight-bold text-secondary">Select User</label>
                                <Select
                                    options={userOptions}
                                    value={userOptions.find(option => option.value === selectedUser)}
                                    onChange={(option) => {
                                        if (option) {
                                            setSelectedUser(option.value);
                                            fetchUserPermissions(option.value);
                                        } else {
                                            resetState();
                                        }
                                    }}
                                    placeholder="Search and select user"
                                    className="border rounded"
                                />
                            </div>
                            <div className="mt-4">
                                <h5 className="text-primary mb-3">People with Access</h5>

                                {sharedPermissions.length === 0 ? (
                                    <p className="text-muted">No permissions assigned.</p>
                                ) : (
                                    sharedPermissions.map(item => (
                                        <div
                                            key={item.rowPermissionId}
                                            className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                                        >
                                            <div>
                                                <strong>{getDisplayName(item)}</strong>

                                                <div className="small text-muted">
                                                    {[
                                                        item.canView && "View",
                                                        item.canEdit && "Edit",
                                                        item.canDelete && "Delete",
                                                        item.canAssign && "Assign"
                                                    ].filter(Boolean).join(", ")}
                                                </div>
                                            </div>

                                            <div className='btn-group'>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => editPermission(item)}
                                                >
                                                    Edit
                                                </Button>

                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => removePermission(item.rowPermissionId)}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </>

                    )}

                    {shareWith === 'UserGroup' && (
                        <>
                            <div className="form-group">
                                <label className="font-weight-bold text-secondary">Select Group</label>
                                <Select
                                    options={groupOptions}
                                    value={groupOptions.find(option => option.value === selectedGroup)}
                                    onChange={(option) => {
                                        setSelectedGroup(option?.value ?? null);
                                    }}
                                    placeholder="Select user group"
                                />
                            </div>
                            <div className="mt-4">
                                <h5 className="text-primary mb-3">People with Group Access</h5>

                                {sharedUserGroups.length === 0 ? (
                                    <p className="text-muted">No permissions assigned.</p>
                                ) : (
                                    sharedUserGroups.map(item => (
                                        <div
                                            key={item.rowPermissionId}
                                            className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                                        >
                                            <div>
                                                <strong>{getDisplayName(item)}</strong>

                                                <div className="small text-muted">
                                                    {[
                                                        item.canView && "View",
                                                        item.canEdit && "Edit",
                                                        item.canDelete && "Delete",
                                                        item.canAssign && "Assign"
                                                    ].filter(Boolean).join(", ")}
                                                </div>
                                            </div>

                                            <div className='btn-group'>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => editPermission(item)}
                                                >
                                                    Edit
                                                </Button>

                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => removePermission(item.rowPermissionId)}
                                                >
                                                    Remove
                                                </Button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div></>

                    )}


                    {/* <div className="form-group mt-3">
                        <label className="font-weight-bold text-secondary">{moduleName} Name</label>
                        <input type="text" className="form-control" value={screenName} readOnly />
                    </div> */}

                    <fieldset className="mt-4 border p-3 rounded">
                        <legend className="w-auto px-2 small text-primary mb-2">Permissions</legend>
                        <div className="d-flex flex-wrap">
                            {[
                                { key: "canView", label: "Can View" },
                                { key: "canEdit", label: "Can Edit" },
                                { key: "canDelete", label: "Can Delete" },
                                { key: "canAssign", label: "Can Assign" }
                            ].map(({ key, label }) => (
                                <div className="form-check form-check-inline mr-4" key={key}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={key}
                                        checked={permissions[key]}
                                        onChange={(e) =>
                                            setPermissions(prev => ({ ...prev, [key]: e.target.checked }))
                                        }
                                    />
                                    <label className="form-check-label" htmlFor={key}>
                                        {label}
                                    </label>
                                </div>
                            ))}
                        </div>


                    </fieldset>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button
                        variant="outline-secondary"
                        onClick={() => {
                            resetState();
                            handleClose();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button type="submit" variant="outline-success">
                        Share
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default ShareModal;
